import {connect} from "react-redux";
import RaisePayment from "./RaisePayment";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../../../service/fileUpload/action";
import {
    bankListRequest,
    loanPaymentRaiseRequest,
    loanAccountRequest,
    loanUndertakingRequest,
    loanPaymentRaiseUpdateRequest,
    loanApplicationByIdRequest,
    loanTranchesRequest,
    loanApprovalRequestRequest
} from "../../../../../service/Dealer/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    bankListResponse: state.Dealer.bankListResponse,
    loanApplicationUpdateResponse: state.Dealer.loanApplicationUpdateResponse,
    loanAccountResponse: state.Dealer.loanAccountResponse,
    loanUndertakingResponse: state.Dealer.loanUndertakingResponse,
    loanPaymentRaiseResponse: state.Dealer.loanPaymentRaiseResponse,
    loanPaymentRaiseUpdateResponse: state.Dealer.loanPaymentRaiseUpdateResponse,
    ucdCaseByIdResponse: state.Dealer.loanApplicationByIdResponse,
    loanTranchesResponse: state.Dealer.loanTranchesResponse,
    loanApprovalRequestResponse: state.Dealer.loanApprovalRequestResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            bankListRequest,
            loanUndertakingRequest,
            loanAccountRequest,
            loanPaymentRaiseRequest,
            loanPaymentRaiseUpdateRequest,
            loanApplicationByIdRequest,
            loanTranchesRequest,
            loanApprovalRequestRequest
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(RaisePayment);
